import { render } from "./iot-insights-tab.vue?vue&type=template&id=5c6c5cd3"
import script from "./iot-insights-tab.vue?vue&type=script&lang=js"
export * from "./iot-insights-tab.vue?vue&type=script&lang=js"

import "./iot-insights-tab.vue?vue&type=style&index=0&id=5c6c5cd3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__